module.exports = __webpack_public_path__ + "static/media/settings.b89caf07.jpg";